import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../../store/state/app.state';
import { getSOSuccessMsg, getSOErrorMsg } from '../../store/selectors/so.selector';
import { SetSOError } from '../../store/actions/so.action';
import { Observable } from 'rxjs';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-company-employee',
  templateUrl: './company-employee.component.html',
  styleUrls: ['./company-employee.component.scss']
})
export class CompanyEmployeeComponent implements OnInit {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map((result:any) => result.matches)
    );

  empolyeeTasks = [ {task : 'MLOs', route : '/MLO-Management'},
                    {task : 'Sales Orders', route : '/SO-Management'},
                    {task : 'Formulation', route : '/Formulation'},
                    {task : 'Forecast Sales', route : '/Forecast-Sales'},
                    {task : 'Customers', route : '/'},
                  
                    {task : 'Materials', route : '/Manage-Materials'},
                    {task : 'Agents', route : '/Agents'},
                    {task : 'Manufacturers', route : '/Manufacturers'},
                    {task : 'Purchase Orders', route : '/'},
                  
                    {task : 'MLOs', route : '/'},
                    {task : 'My Action List MLOs', route : '/'},
                    {task : 'QA MLOs', route : '/'},
                    
                    {task : 'Warehouse Material Receive', route : '/'},
                    {task : 'Warehouse Customer Shipment', route : '/'},
                    {task : 'Warehouse MLO Internal Release', route : '/'},
                    {task : 'Warehouse MLO Internal Receive', route : '/'}, 
                    {task : 'Warehouse Internal Return', route : '/'},
                    {task : 'Warehouse Reject', route : '/'},
                    {task : 'Reports', route : '/EMP-Reports'}]
  constructor(private store : Store<IAppState>,
              private breakpointObserver : BreakpointObserver) { }

  ngOnInit() {
    this.getSubscribeSO();
  }

  getSubscribeSO() {
    this.store.pipe(select(getSOSuccessMsg)).subscribe((result : any) => {
      if(!!result)
      console.log(result)
    })
    this.store.pipe(select(getSOErrorMsg)).subscribe((result : any) => {
      if(!!result && !!result.data){
        alert(`${result.from} is ${result.data.error}` )
        this.store.dispatch(new SetSOError(null, null))
      }      
    })
  }
}
